import i18n from './index'

const rtlLanguages = ['ar', 'he', 'fa', 'ur']

export const getLangBase = (lang) => lang.split('-')[0]
export const isRTL = (lang = getLang()) => rtlLanguages.includes(getLangBase(lang))

export const setLang = (lang = getLang()) => {
  i18n.changeLanguage(lang)
  document.documentElement.lang = lang
  document.documentElement.dir = isRTL(lang) ? 'rtl' : 'ltr'
}

export const getLang = () => getLangBase(i18n.language)
